<template>
  <div class="clearfix">
    <job-preview-right-column
      :text-count-mode="textCountMode"
      :highlight-mode="highlightMode"
      comment-class="inner"
      :comment-highlights="commentHighlights"
      text-count-class="content"
      :text-counts="textCounts"
      v-on="$listeners"
    />
    <slot name="catch" />
    <slot name="body">
      <p
        v-if="value"
        :id="targetId"
        :class="valueClass"
        class="pega-pre-wrap"
        data-test="value"
        v-text="value"
      />
    </slot>
    <div class="clearfix" />
    <slot name="supplement" />
    <slot name="sub" />
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import JobPreviewRightColumn from '@/components/molecules/JobPreviewRightColumn'

export default {
  components: {
    JobPreviewRightColumn
  },
  props: {
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      default: false
    },
    textCountMode: {
      type: Boolean,
      default: false
    },
    textCounts: {
      type: Array,
      default: () => []
    },
    targetId: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: ''
    },
    valueClass: {
      type: String,
      default: ''
    }
  }
}
</script>
